export default __webpack_public_path__ + "static/media/es-buurebueebli.da28c794.webp";